import { Typography } from "@joonapp/web-shared"
import { useState } from "react"

import useMediaQuery from "../../hooks/useMediaQuery"

const ReferralPreviewCard = ({
  preview,
  inCarousel = false,
}: {
  preview: {
    text: string
    image: string
  }
  inCarousel?: boolean
}) => {
  const { text, image } = preview
  const [isImageLoaded, setIsImageLoaded] = useState(false)
  const isSmallScreen = useMediaQuery("(max-width: 400px)")

  return (
    <div
      className="bg-white rounded-lg border border-borderPrimary overflow-hidden"
      style={{
        ...(inCarousel
          ? {
              width: "calc(100% - 16px)",
              height: "auto",
              margin: "0 8px",
            }
          : {
              minWidth: "350px",
              maxWidth: "350px",
              minHeight: "450px",
              maxHeight: "450px",
              boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.1)",
            }),
      }}
    >
      <div
        className={`p-4 flex items-center justify-start ${
          isSmallScreen ? "" : inCarousel ? "min-h-10" : "h-20"
        }`}
      >
        <Typography
          variant={
            isSmallScreen
              ? "bodyXSmallBold"
              : inCarousel
                ? "bodySmallBold"
                : "bodyBold"
          }
        >
          {text}
        </Typography>
      </div>
      <img
        src={image}
        alt={text}
        onLoad={() => setIsImageLoaded(true)}
        className="w-full h-full object-contain"
        style={{
          pointerEvents: "none",
          userSelect: "none",
          opacity: isImageLoaded ? 1 : 0,
          transition: "opacity 0.3s ease-in-out",
        }}
      />
    </div>
  )
}

export default ReferralPreviewCard
